import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.content.comparisons');
import { OnInit, OnDestroy, HostListener, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-content-comparisons',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.content.comparisons/view.scss */
:host {
  min-width: 0;
  container: page-content-comparisons/inline-size;
  display: block;
  min-width: 0;
  min-height: 100%;
  color: #172033;
  background: var(--wb-page-canvas, #f5f9fd);
}

.comparison-page {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 24px 28px 48px;
}

h2, h3, h4, p {
  margin: 0;
}

/* Match the underline navigation used by scenario detail pages. */
.wb-workspace-nav {
  display: flex;
  gap: 6px;
  margin-bottom: 14px;
  padding: 0;
  border: 0;
  border-bottom: 1px solid #dbe6f3;
  border-radius: 0;
  background: transparent;
}

.wb-workspace-nav a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  min-height: 48px;
  padding: 11px 18px;
  border: 0;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  background: transparent;
  color: #56739a;
  font-size: 14px;
  font-weight: 800;
  line-height: 22px;
  text-align: center;
  text-decoration: none;
  word-break: keep-all;
}

.wb-workspace-nav a i {
  flex: none;
  font-size: 16px;
}

.wb-workspace-nav a:hover {
  color: #125dd6;
  background: #eef5ff;
}

.wb-workspace-nav a.is-active {
  border-bottom-color: #1367ed;
  background: transparent;
  color: #1262e6;
  box-shadow: none;
}

.wb-workspace-nav a:focus-visible {
  outline: 3px solid #93c5fd;
  outline-offset: -3px;
}

.comparison-page-heading {
  margin-bottom: 20px;
}

.comparison-page-heading h2 {
  color: #0d1c4d;
  font-size: 27px;
  font-weight: 800;
  line-height: 1.25;
}

.comparison-page-heading p {
  margin-top: 5px;
  color: #56709a;
  font-size: 13px;
  line-height: 1.6;
}

.comparison-cell-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 12px;
  margin-bottom: 8px;
  color: #7186a4;
  font-size: 12px;
}

.comparison-pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
  color: #547092;
  font-size: 13px;
}

.comparison-pagination > div {
  display: flex;
  gap: 8px;
}

.comparison-pagination button {
  min-height: 40px;
  padding: 8px 14px;
  border: 1px solid #cdddf3;
  border-radius: 7px;
  background: #fff;
  color: #1d5bbf;
}

.comparison-pagination button:disabled {
  opacity: 0.45;
  cursor: default;
}

.comparison-empty .comparison-back {
  margin-top: 16px;
}

h2 {
  color: #13284d;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.45;
}

h3 {
  color: #17335a;
  font-size: 15px;
  font-weight: 750;
  line-height: 1.45;
}

h4 {
  color: #25446f;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
}

button:focus-visible, a:focus-visible, select:focus-visible, summary:focus-visible {
  outline: 2px solid #1765e7;
  outline-offset: 3px;
}

button, select {
  font: inherit;
}

button {
  cursor: pointer;
}

button:disabled {
  cursor: default;
}

a {
  color: #1763d6;
  text-decoration: none;
}

.comparison-toolbar,
.comparison-intro,
.comparison-scenario > header,
.comparison-model > header,
.comparison-cell-heading,
.comparison-preview > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
}

.comparison-toolbar {
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.comparison-back,
.comparison-scenario > header > a,
.comparison-progress button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 13px;
  border: 1px solid #cdddf3;
  border-radius: 7px;
  background: #fff;
  color: #1d5bbf;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
}

.comparison-back:hover,
.comparison-scenario > header > a:hover,
.comparison-progress button:hover {
  border-color: #4388ed;
  background: #f4f8ff;
}

.comparison-picker {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: #547092;
  font-size: 12px;
  font-weight: 700;
}

.comparison-picker > span {
  flex-shrink: 0;
}

.comparison-picker select {
  min-width: 0;
  width: 300px;
  max-width: 100%;
  min-height: 40px;
  padding: 8px 32px 8px 12px;
  border: 1px solid #d5e1f1;
  border-radius: 7px;
  background: #fff;
  color: #17335a;
  font-size: 13px;
  font-weight: 500;
}

.comparison-intro,
.comparison-references,
.comparison-model {
  border: 1px solid #dbe6f4;
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 3px 14px rgba(37, 72, 123, 0.035);
}

.comparison-intro {
  padding: 20px 22px;
}

.comparison-intro > div:first-child {
  min-width: 0;
}

.comparison-intro p,
.comparison-scenario > header p,
.comparison-model > header p {
  margin-top: 5px;
  color: #7186a4;
  font-size: 12px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.comparison-progress {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px 10px;
}

.comparison-progress strong {
  color: #1763d6;
  font-size: 18px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.comparison-progress > span {
  color: #7186a4;
  font-size: 12px;
}

.comparison-progress button {
  margin-left: 6px;
  white-space: nowrap;
}

.comparison-references {
  margin-top: 18px;
  padding: 20px 22px;
}

.comparison-references h2 {
  margin-bottom: 12px;
  font-size: 15px;
}

.comparison-reference-help {
  margin: -4px 0 14px;
  color: #7186a4;
  font-size: 12px;
  line-height: 1.6;
}

.comparison-reference-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.comparison-reference-grid button {
  display: grid;
  gap: 7px;
  min-width: 0;
  padding: 12px;
  border: 1px solid #e1eaf6;
  border-radius: 7px;
  background: #fff;
  color: #25446f;
  font-size: 13px;
  text-align: left;
  overflow-wrap: anywhere;
}

.comparison-reference-grid button:hover:not(:disabled) {
  border-color: #8ab7f5;
  background: #f8fbff;
}

.comparison-reference-grid img {
  width: 100%;
  height: 135px;
  object-fit: contain;
  border-radius: 5px;
  background: #f5f8fd;
}

.comparison-reference-grid small {
  color: #7186a4;
  font-size: 12px;
  line-height: 1.5;
}

.comparison-reference-origin {
  justify-self: start;
  padding: 3px 7px;
  border-radius: 4px;
  background: #edf4ff;
  color: #3770c0;
  font-size: 12px;
  font-weight: 700;
}

.comparison-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin: 20px 0;
  padding: 8px;
  border: 1px solid #dbe6f4;
  border-radius: 9px;
  background: #fff;
}

.comparison-tabs button {
  min-width: 0;
  min-height: 40px;
  padding: 8px 13px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: #547092;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
}

.comparison-tabs button:hover {
  background: #f4f8ff;
}

.comparison-tabs button.is-active {
  border-color: #bfd5f8;
  background: #eef5ff;
  color: #0958d9;
}

.comparison-scenario {
  margin-top: 24px;
}

.comparison-scenario > header {
  align-items: flex-start;
  margin-bottom: 14px;
}

.comparison-scenario > header > div {
  min-width: 0;
}

.comparison-scenario > header h2 {
  overflow-wrap: anywhere;
}

.comparison-scenario > header > a {
  flex-shrink: 0;
}

.comparison-model {
  margin-bottom: 16px;
  overflow: hidden;
}

.comparison-model > header {
  align-items: flex-start;
  padding: 16px 20px;
  border-bottom: 1px solid #e6edf7;
  background: #f8faff;
}

.comparison-model > header h3 {
  flex-shrink: 0;
}

.comparison-model > header p {
  max-width: 65%;
  margin: 0;
}

.comparison-images {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  padding: 18px 20px;
}

.comparison-cell {
  min-width: 0;
}

.comparison-cell-heading {
  gap: 8px;
  margin-bottom: 10px;
}

.comparison-cell-heading > span {
  flex-shrink: 0;
  padding: 3px 7px;
  border-radius: 5px;
  background: #edf4ff;
  color: #3770c0;
  font-size: 12px;
  font-weight: 600;
}

.comparison-cell-heading > span.is-complete {
  background: #e9f8ef;
  color: #16794f;
}

.comparison-cell-heading > span.is-error {
  background: #fff0ee;
  color: #b42318;
}

.comparison-cell-heading > span.is-muted {
  background: #f1f5f9;
  color: #64748b;
}

.comparison-image-button {
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
  border: 1px solid #dfe8f5;
  border-radius: 7px;
  background: #f5f8fd;
}

.comparison-image-button:hover:not(:disabled) {
  border-color: #8ab7f5;
}

.comparison-image-button img {
  display: block;
  width: 100%;
  aspect-ratio: 4/3;
  object-fit: contain;
}

.comparison-placeholder {
  display: grid;
  min-height: 220px;
  place-items: center;
  color: #7186a4;
  font-size: 13px;
}

.comparison-cell-reference {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #dce7f4;
  border-radius: 7px;
  background: #f8fbff;
  color: #183453;
  text-align: left;
}

.comparison-cell-reference > img {
  flex: 0 0 60px;
  width: 60px;
  height: 46px;
  object-fit: contain;
  border-radius: 4px;
  background: #fff;
}

.comparison-cell-reference > span {
  display: grid;
  gap: 4px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.comparison-cell-reference small {
  color: #7186a4;
  font-size: 12px;
  line-height: 1.4;
}

.comparison-cell-reference strong {
  color: #25446f;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.5;
}

.comparison-cell-reference:hover:not(:disabled) {
  border-color: #8ab7f5;
  background: #eef5ff;
}

.comparison-prompt {
  margin-top: 12px;
  color: #547092;
  font-size: 12px;
}

.comparison-prompt summary {
  min-height: 40px;
  padding: 10px 12px;
  border: 1px solid #e1eaf6;
  border-radius: 6px;
  background: #f8faff;
  color: #486992;
  font-weight: 600;
  cursor: pointer;
}

.comparison-prompt pre {
  max-height: 340px;
  margin: 8px 0 0;
  padding: 12px;
  overflow: auto;
  border: 1px solid #e1eaf6;
  border-radius: 6px;
  background: #f8faff;
  font-family: inherit;
  font-size: 12px;
  line-height: 1.7;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.comparison-error {
  margin: 12px 0;
  padding: 14px 18px;
  border: 1px solid #f3bbb6;
  border-radius: 8px;
  background: #fff7f6;
  color: #ac4137;
  font-size: 13px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.comparison-loading,
.comparison-empty {
  display: grid;
  justify-items: center;
  gap: 12px;
  padding: 48px 20px;
  border: 1px solid #dbe6f4;
  border-radius: 9px;
  background: #fff;
  color: #7186a4;
  font-size: 13px;
  text-align: center;
}

.comparison-empty > i, .comparison-loading > i {
  color: #6c91c6;
  font-size: 24px;
}

.comparison-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: grid;
  align-items: start;
  justify-items: center;
  padding: 24px;
  overflow: auto;
  overscroll-behavior: contain;
  background: rgba(16, 44, 58, 0.65);
}

.comparison-preview {
  width: min(1100px, 100%);
  min-width: 0;
  padding: 20px;
  border: 1px solid #dbe6f4;
  border-radius: 12px;
  background: #fff;
  box-shadow: var(--wb-shadow-md);
}

.comparison-preview > header {
  align-items: flex-start;
  margin-bottom: 16px;
}

.comparison-preview h2 {
  min-width: 0;
  font-size: 16px;
  overflow-wrap: anywhere;
}

.comparison-preview button {
  flex-shrink: 0;
  min-height: 40px;
  padding: 8px 13px;
  border: 1px solid #cdddf3;
  border-radius: 7px;
  background: #fff;
  color: #1d5bbf;
  font-size: 12px;
  font-weight: 700;
}

.comparison-preview > img {
  display: block;
  width: 100%;
  max-height: 78vh;
  object-fit: contain;
}

@container page-content-comparisons (max-width: 1000px) {
  .comparison-intro, .comparison-model > header {
    align-items: flex-start;
    flex-direction: column;
  }
  .comparison-model > header p {
    max-width: 100%;
  }
  .comparison-cell-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }
  .comparison-images {
    gap: 12px;
    padding: 16px;
  }
}
@container page-content-comparisons (max-width: 720px) {
  .comparison-page {
    padding: 18px 18px 32px;
  }
  .comparison-toolbar {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }
  .comparison-back {
    align-self: flex-start;
  }
  .comparison-picker {
    width: 100%;
  }
  .comparison-picker select {
    flex: 1;
    width: 0;
  }
  .comparison-intro, .comparison-references {
    padding: 18px;
  }
  .comparison-progress {
    gap: 6px 8px;
  }
  .comparison-progress button {
    margin-left: 0;
  }
  .comparison-scenario > header {
    flex-direction: column;
    gap: 10px;
  }
  .comparison-scenario > header h2, .comparison-intro h2 {
    font-size: 16px;
  }
}
@container page-content-comparisons (max-width: 640px) {
  .comparison-images {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .comparison-cell-heading {
    align-items: center;
    flex-direction: row;
  }
  .comparison-reference-grid {
    grid-template-columns: 1fr;
  }
  .comparison-reference-grid img {
    height: 160px;
  }
  .comparison-tabs button {
    width: 100%;
  }
  .comparison-model > header {
    padding: 14px 16px;
  }
  .comparison-overlay {
    padding: 12px;
  }
  .comparison-preview {
    padding: 14px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .comparison-loading > i {
    animation: none;
  }
}
@container page-content-comparisons (max-width: 650px) {
  .comparison-page {
    padding-inline: 12px;
  }
  .wb-workspace-nav a {
    flex: 1;
    gap: 6px;
    padding-inline: 6px;
    font-size: 14px;
  }
  .wb-workspace-nav a i {
    font-size: 16px;
  }
}`],
})
export class PageContentComparisonsComponent implements OnInit, OnDestroy {
    public loading = true;
    public errorMessage = '';
    public collections: any[] = [];
    public collection: any = null;
    public collectionId = '';
    public sourceLabel = '';
    public sourceKind: 'patient' | 'scenario' = 'patient';
    public sourceId = '';
    public sourceQueryParams: any = {};
    public resultPage = 1;
    public resultTotal = 0;
    public readonly resultPageSize = 50;
    public references: any[] = [];
    public preview: any = null;
    public readonly expressions: any = { realistic: '사실적 묘사', trigger: '트리거 요소', blur: '블러 처리' };
    private timer: any = null;
    private destroyed = false;
    public fetching = false;
    private routeSubscription: Subscription | null = null;
    private contextSequence = 0;
    private loadSequence = 0;
    private previewReturn: HTMLElement | null = null;

    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute,@Inject( Router)  private router: Router,@Inject( ChangeDetectorRef)  private changeDetector: ChangeDetectorRef) {}

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        if (this.destroyed) return;
        this.routeSubscription = this.route.queryParamMap.subscribe(params => void this.loadContext(params));
    }

    private async loadContext(params: ParamMap) {
        const sequence = ++this.contextSequence;
        ++this.loadSequence;
        window.clearTimeout(this.timer);
        this.loading = true;
        this.collection = null;
        this.collections = [];
        this.references = [];
        this.preview = null;
        this.sourceLabel = '';
        this.errorMessage = '';
        const patientId = String(params.get('patient_id') || '').toLowerCase();
        const scenarioId = String(params.get('scenario') || '').toUpperCase();
        const scenarioMode = params.get('source') === 'scenario';
        if (scenarioMode && /^(?:[A-Z]{2}-\d{2}|[A-Z]\d{2}|IM[0-9A-F]{14})$/.test(scenarioId) && !patientId) {
            this.sourceKind = 'scenario';
            this.sourceId = scenarioId;
            this.sourceQueryParams = {source: 'scenario', scenario: scenarioId, memory: params.get('memory') === 'positive' ? 'positive' : 'trauma'};
        } else if (!scenarioMode && /^[a-f0-9]{32}$/.test(patientId) && !scenarioId) {
            this.sourceKind = 'patient';
            this.sourceId = patientId;
            const resourceMode = params.get('memory_mode') === 'resource';
            const resourceId = String(params.get('resource_memory_id') || '');
            this.sourceQueryParams = {patient_id: patientId, memory_mode: resourceMode ? 'resource' : null,
                resource_memory_id: resourceMode && /^[a-f0-9]{32}$/.test(resourceId) ? resourceId : null};
        } else {
            await this.router.navigate(['/content'], {replaceUrl: true});
            return;
        }
        this.resultPage = Math.max(1, Math.min(1000000, Math.floor(Number(params.get('page'))) || 1));
        try {
            const { code, data } = await wiz.app('page.content').call('comparison_collections', this.scopeRequest());
            if (this.destroyed || sequence !== this.contextSequence) return;
            if (code !== 200) throw new Error(data?.message || '비교 목록을 불러오지 못했습니다.');
            this.sourceLabel = data.source?.label || this.sourceId;
            this.collections = [{id: 'current', title: '현재 생성 결과'}, ...(data.collections || [])];
            this.collectionId = this.collections.some(item => item.id === params.get('id')) ? params.get('id')! : 'current';
            await this.load();
        } catch (error: any) {
            if (sequence === this.contextSequence && !this.destroyed) this.errorMessage = error.message;
        } finally {
            if (sequence === this.contextSequence && !this.destroyed) {
                this.loading = false;
                await this.service.render();
            }
        }
    }

    public ngOnDestroy() { this.destroyed = true; ++this.contextSequence; ++this.loadSequence; this.routeSubscription?.unsubscribe(); window.clearTimeout(this.timer); }

    private scopeRequest() {
        return this.sourceKind === 'scenario'
            ? {source_mode: 'scenario', scenario_set_id: this.sourceId, memory_kind: this.sourceQueryParams.memory}
            : {source_mode: 'patient', patient_id: this.sourceId, memory_mode: this.sourceQueryParams.memory_mode || 'trauma',
                resource_memory_id: this.sourceQueryParams.resource_memory_id || ''};
    }

    public async selectCollection() {
        await this.router.navigate([], { relativeTo: this.route, queryParams: {...this.sourceQueryParams, id: this.collectionId} });
    }

    public resultPageCount() { return Math.max(1, Math.ceil(this.resultTotal / this.resultPageSize)); }
    public async selectPage(page: number) {
        if (this.fetching || page < 1 || page > this.resultPageCount()) return;
        await this.router.navigate([], {relativeTo: this.route, queryParams: {...this.sourceQueryParams, id: 'current', page}});
    }

    private currentCollection(data: any) {
        const jobs = (data.jobs || []).filter((job: any) => job.media_type === 'image' && (
            this.sourceKind === 'scenario' ? job.source_kind === 'scenario' && job.source_key === this.sourceId + ':' + this.sourceQueryParams.memory
                : job.patient_id === this.sourceId && job.source_kind !== 'scenario'
        ));
        this.resultTotal = Number(data.total || 0);
        const groups = new Map<string, any>();
        for (const job of jobs) {
            const cutOrder = Number(job.scenario_cut_order || 0);
            const key = String(cutOrder);
            if (!groups.has(key)) groups.set(key, {id: key, title: this.sourceLabel,
                cut_title: job.scenario_cut_title || (this.sourceQueryParams.memory_mode === 'resource' ? '자원 기억' : '전체 생성 결과'),
                cut_order: cutOrder, rows: []});
            const group = groups.get(key);
            const modelKey = String(job.model_name || job.model || job.provider_name || '생성 모델');
            let row = group.rows.find((item: any) => item.model_key === modelKey);
            if (!row) { row = {model_key: modelKey, model_label: modelKey, prompt_note: '', cells: []}; group.rows.push(row); }
            row.cells.push({job_id: job.id || job.job_id, expression: job.image_expression || 'realistic',
                expression_label: job.image_expression_name || this.expressions[job.image_expression || 'realistic'],
                intensity: job.image_expression_uses_intensity === false ? null : job.intensity,
                status: job.status, error: job.error_message || '', asset: job.asset_revision_id ? job : null,
                created: job.created_at || job.created, prompt: ''});
        }
        return {id: 'current', title: this.sourceLabel + ' · 현재 생성 결과',
            description: '모델·표현 방식·강도별 이미지 생성 결과를 확인합니다.', references: [],
            scenarios: [...groups.values()].sort((a, b) => a.cut_order - b.cut_order),
            total: jobs.length, completed: jobs.filter((job: any) => !!job.asset_revision_id).length};
    }

    public async load() {
        if (this.destroyed || !this.collectionId) return;
        const sequence = ++this.loadSequence;
        this.fetching = true;
        window.clearTimeout(this.timer);
        try {
            const current = this.collectionId === 'current';
            const { code, data } = await wiz.app('page.content').call(current ? 'search' : 'comparison_results', {
                ...this.scopeRequest(), collection: this.collectionId, media_type: 'image', page: this.resultPage, dump: this.resultPageSize
            });
            if (this.destroyed || sequence !== this.loadSequence) return;
            if (code !== 200) throw new Error(data?.message || '생성 결과를 불러오지 못했습니다.');
            const collection = current ? this.currentCollection(data) : data.collection;
            this.errorMessage = '';
            const references = new Map<string, any>();
            await Promise.all([...new Set((collection.references || []).filter((item: any) => item.kind !== 'library' && item.scenario_id === this.sourceId).map((item: any) => String(item.scenario_id)))].map(async scenarioId => {
                const response = await wiz.app('page.scenario.sets').call('scenario_photos', { scenario_id: scenarioId });
                if (response.code === 200) for (const photo of response.data?.items || []) references.set(photo.id, photo);
            }));
            if (this.destroyed || sequence !== this.loadSequence) return;
            this.collection = collection;
            this.references = (collection.references || []).map((item: any) => ({ ...item,
                url: item.kind === 'library' ? this.libraryImageUrl(item.image_url) : this.safeUrl(references.get(item.photo_id)?.preview_url) }));
            const libraryReferences = new Map(this.references.filter((item: any) => item.kind === 'library').map((item: any) => [item.reference_id, item]));
            for (const scenario of this.collection.scenarios) for (const row of scenario.rows) for (const cell of row.cells) {
                cell.reference = libraryReferences.get(cell.reference_id) || null;
            }
            if (this.preview?.job_id) {
                const next = this.collection.scenarios.flatMap((s: any) => s.rows.flatMap((r: any) => r.cells)).find((c: any) => c.job_id === this.preview.job_id);
                if (next) this.preview = { ...next, title: this.preview.title, url: this.masterUrl(next.asset) };
            }
        } catch (error: any) {
            if (!this.destroyed && sequence === this.loadSequence) {
                this.collection = null;
                this.references = [];
                this.errorMessage = error.message;
            }
        }
        finally {
            if (this.destroyed || sequence !== this.loadSequence) return;
            this.fetching = false;
            if (!this.destroyed) this.timer = window.setTimeout(() => this.load(), this.collection?.completed === this.collection?.total ? 45000 : 10000);
            await this.service.render();
        }
    }

    public scenarios() { return this.collection?.scenarios || []; }
    public hasLibraryReferences() { return this.references.some((reference: any) => reference.kind === 'library'); }
    private safeUrl(value: any) { return String(value || '').startsWith('/api/ptsd/assets/file?') ? String(value) : ''; }
    private libraryImageUrl(value: any) {
        try {
            const url = new URL(String(value || ''));
            return url.protocol === 'https:' && !url.username && !url.password && (!url.port || url.port === '443')
                && ['archive.much.go.kr', 'archives-files.seoul.go.kr', 'archive.heritage.gangwon.kr', 'www.incheon.go.kr'].includes(url.hostname)
                ? url.href : '';
        } catch { return ''; }
    }
    public masterUrl(asset: any) { return this.safeUrl(asset?.signed_url || asset?.asset?.signed_url); }
    public imageUrl(asset: any) {
        const thumbnail = (asset?.artifacts || asset?.asset?.artifacts || []).find((a: any) => (a.role || a.artifact_role) === 'thumbnail');
        return this.safeUrl(thumbnail?.signed_url) || this.masterUrl(asset);
    }
    public statusLabel(status: string) {
        return ({ waiting: '생성 준비 중', queued: '대기 중', running: '생성 중', postprocessing: '저장 중', review_pending: '생성 완료', approved: '생성 완료', failed: '생성 실패', quarantined: '검토 필요', unavailable: '결과를 불러올 수 없습니다', cancelled: '취소됨' } as any)[status] || status;
    }
    public open(cell: any, title: string) {
        this.previewReturn = document.activeElement as HTMLElement;
        this.preview = { ...cell, title, url: this.masterUrl(cell.asset) };
        this.changeDetector.detectChanges();
        this.changeFocus();
    }
    public openReference(reference: any) {
        this.previewReturn = document.activeElement as HTMLElement;
        this.preview = { title: reference.label, url: reference.url, prompt: '' };
        this.changeDetector.detectChanges();
        this.changeFocus();
    }
    private changeFocus() { window.setTimeout(() => document.getElementById('comparison-preview-close')?.focus(), 0); }
    @HostListener('document:keydown.escape')
    public closePreview() { if (!this.preview) return; this.preview = null; this.changeDetector.detectChanges(); this.previewReturn?.focus(); }
}

export default PageContentComparisonsComponent;